// removed by extract-text-webpack-plugin
module.exports = {"moduleSection":"_2aOpy25vcEVDrQ0aK0vLru","moduleSectionHeading":"_1xwWx_7lKNWf9sNW2xm20E","emailDefault":"_1uOBY5S-N5rmI4VznB162p","phoneDefault":"_3pbr0lBckZYmlMmDaoaNR6","email":"_1DXeI0-nXVWf_tisnJXF40","phone":"pv9ycLkp_BZtcUkHSmw6S","editClientProfile":"_133JTWb89syDPmQ1Xqqc1N"};


//////////////////
// WEBPACK FOOTER
// ./components/b2bCompany/b2bCompanyClientProfile.scss
// module id = 1588
// module chunks = 0